import { Component, input, Input } from '@angular/core';
import { BatteryState } from '../../models/enums/battery-state.enum';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'web-batterie-icon',
    templateUrl: './batterie-icon.component.html',
    styleUrls: ['./batterie-icon.component.scss'],
    imports: [CommonModule],
})
export class BatterieIconComponent {
    @Input()
    batterieState?: BatteryState;

    public readonly batteriePourcentage = input<number | undefined>(undefined);

    public getIconClass(): string {
        switch (this.batterieState) {
            case BatteryState.CHARGING:
                return 'filled charging';
            case BatteryState.DISCHARGING:
            case BatteryState.OFFGRID_DISCHARGING:
                return 'filled discharging';
            case BatteryState.NOT_SUPPORTED:
            case BatteryState.UNPLUGGED:
                return 'unplugged';
            case BatteryState.OFF:
            default:
                return 'filled';
        }
    }
}
